<template>
  <div class="header">
    <img src="@/assets/image/logo.png" alt="logo" class="logo" />
    <div class="nav">
      <div class="navlist">
        <div
          class="navitem"
          v-for="(item, index) in headerList"
          :key="index"
          :class="{ active: isActive(item) }"
          @click="changepath(item)"
        >
          <span>{{ item.name }}</span>
          <div class="navboximg" v-if="item.children || item.classtype" />
          <div class="navboxtop" v-if="item.classtype">
            <div
              class="navinfoitem"
              v-for="(classitem, index) in item.classtype"
               :class="{navboxtopitemactive: index == classtypeIndex}"
              :key="index"
              @click="getclassindex(index)"
            >
              {{ classitem.name }}
              <div class="navbox product">
                <div
                  class="navboxitem"
                  :class="{
                    navboxitemactive:
                      $route.params.id == gameitem.gameclassid &&
                      activeIndex == gameitem.path,
                  }"
                  v-for="(gameitem, index) in classitem.children"
                  :key="index"
                  @click.stop="changechildpath(gameitem)"
                >
                  {{ gameitem.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="navbox default" v-if="!item.classtype">
            <div
              class="navboxitem"
              :class="{
                navboxitemactive:
                  $route.params.id == gameitem.gameclassid &&
                  activeIndex == gameitem.path,
              }"
              v-for="(gameitem, index) in item.children"
              :key="index"
              @click.stop="changechildpath(gameitem)"
            >
              {{ gameitem.name }}
            </div>
          </div>
          <div class="activeline"></div>
        </div>
      </div>
    </div>
    <!-- <div class="language">
      <div
        class="text"
        @click="changelang('CN')"
        :class="{ activetext: language == 'CN' }"
      >
        简
      </div>
      <div class="line"></div>
      <div
        class="text"
        @click="changelang('EN')"
        :class="{ activetext: language == 'EN' }"
      >
        EN
      </div>
    </div> -->
  </div>
</template>

<script>
import { getgamelist } from "@/utils/api";

export default {
  data() {
    return {
      headerList: [
        { path: "/home", name: "首页" },
        { path: "/about", name: "关于我们" },
        {
          path: "",
          name: "产品图鉴",
          classtype: [
            { id: 1, name: "卡牌", children: [] },
            { id: 2, name: "谷子", children: [] },
          ],
        },
        {
          path: "",
          name: "商品动态",
          children: [
            {
              path: "/dynamic",
              gameclassid: 1,
              name: "品牌介绍",
              type: "dy",
            },
            {
              path: "/dynamic",
              gameclassid: 2,
              name: "授权IP",
              type: "dy",
            },
          ],
        },
        {
          path: "/task",
          name: "业务渠道",
        },
        {
          path: "/contact",
          name: "联系我们",
        },
      ],
      activeIndex: "/home",
      language: "CN",
      savedActiveIndex: "savedActiveIndex",
      pagePath: "",
      classtypeIndex: null,
      isShow: false,

      classtypecard: 1,
      classtypegu: 0,
      test1: [],
      test2:[]
    };
  },
  created() {
    this.pagePath = sessionStorage.getItem(this.savedActiveIndex);
    if (this.pagePath && this.pagePath.split("/")[2] != undefined) {
      this.$nextTick(() => {
        this.activeIndex = "/" + this.pagePath.split("/")[1];
      });
    }
    if (this.pagePath) {
      this.activeIndex = this.pagePath;
    }
    this.init();
    if(sessionStorage.getItem("classtypecard")) {
        this.classtypecard = sessionStorage.getItem("classtypecard")
        this.classtypeIndex = (this.classtypecard == 0) ? 1 : 0;
      }
  },
  methods: {
    async init() {
      this.test1 = await getgamelist({
        page: 1,
        size: 10,
        cardIs: 1,
        guzIs: 0,
      });
      this.test1 = this.test1.records;
      this.test1 = this.test1
        .map((item) => ({
          ...item,
          type: "game",
          path: "/product",
          gameclassid: item.id,
        }))
        .sort((a, b) => a.sortCode - b.sortCode);
      this.headerList[2].children = this.test1;
      this.headerList[2].classtype[0].children = this.test1;
   
       this.test2 = await getgamelist({
        page: 1,
        size: 10,
        cardIs: 0,
        guzIs: 1,
      });
      this.test2 = this.test2.records;
      this.test2 = this.test2
        .map((item) => ({
          ...item,
          type: "game",
          path: "/product",
          gameclassid: item.id,
        }))
        .sort((a, b) => a.sortCode - b.sortCode);
      this.headerList[2].children = this.test1;
      this.headerList[2].classtype[1].children = this.test2;
      console.log(this.test2);
      
    },
    //路由跳转
    changepath(item) {
      if (item.path == this.$route.path || item.path == "") return;
      this.activeIndex = item.path;
      sessionStorage.setItem(this.savedActiveIndex, item.path);
      this.$router.push(item.path);
      this.classtypeIndex = null//卡牌数据归0
      sessionStorage.setItem('classtypecard', 0);
    },
    getclassindex(index) {
      this.classtypeIndex = index;
      if(index == 0) {
        this.classtypecard = 1
        this.classtypegu = 0
      } else {
         this.classtypecard = 0
         this.classtypegu = 1
      }
      sessionStorage.setItem('classtypecard', this.classtypecard);
      sessionStorage.setItem('classtypegu', this.classtypegu);
    },

    changechildpath(item) {
      let newpath = sessionStorage.getItem(this.savedActiveIndex);
      if (newpath == `${item.path}/${item.gameclassid}`) return;
      this.$router.push({
        path: `${item.path}/${item.gameclassid}`,
      });
      this.activeIndex = item.path;
      sessionStorage.setItem(
        this.savedActiveIndex,
        `${item.path}/${item.gameclassid}`
      );

      //ip区分模块
      if(item.cardIs || item.guzIs) {
        if(item.guzIs) {
          this.classtypecard = 0
          this.classtypegu = 1
          this.classtypeIndex = 1
        } else {
          this.classtypecard = 1
          this.classtypegu = 0
           this.classtypeIndex = 0
        }
      sessionStorage.setItem('classtypecard', this.classtypecard);
      sessionStorage.setItem('classtypegu', this.classtypegu);
      }
    },

    isActive(item) {
      if (
        item.children &&
        item.children.some((child) => child.path == this.activeIndex)
      ) {
        return true;
      }
      return item.path === this.activeIndex;
    },

    //游戏系列切换，或者是后续的id切换，看后期数据情况进行确定
    changedata(gameitem) {
      return gameitem;
    },

    // //语言切换
    // changelang(id) {
    //   this.language = id;
    // },
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  align-items: center;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  height: 82px;
  background-color: rgba(0, 0, 0, 0.75);
  justify-content: space-between;
  z-index: 16;

  .logo {
    position: absolute;
    left: 161px;
    width: 127px;
    height: 38px;
  }

  .nav {
    margin: 0 auto;
  }

  .navlist {
    display: flex;
    margin: 0 auto;

    .navitem {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 142px;
      height: 82px;
      cursor: pointer;

      .activeline {
        position: absolute;
        left: 50%;
        top: 0;
        height: 10px;
        background-color: #e62c3d;
        width: 0;
        transform: translate(-50%, 0);
        transition: width 0.3s ease;
      }

      span {
        font-size: 16px;
        color: #ffffff;
      }

      .navboximg {
        width: 16px;
        height: 16px;
        background-image: url("@/assets/image/header/arrowbottom.png");
        background-size: cover;
        margin-left: 5px;
        transition: transform 0.5s;
      }

      .navbox,
      .navboxtop {
        display: none;
        position: absolute;
        width: 100%;
        left: 0;
        top: 82px;
        z-index: 5;

        .navboxitem,
        .navinfoitem {
          height: 60px;
          color: #fff;
          text-align: center;
          font-size: 14px;
          line-height: 60px;
          border-top: 1px solid rgba(255, 255, 255, 0.3);
        }
        .navinfoitem {
          position: relative;
          background-color: rgba(0, 0, 0, 0.5);
        }

        .navboxitem:hover,
        .navboxitemactive {
          color: #e62c3d;
        }

        .navboxitem:nth-child(1) {
          border: 0;
        }
        .navinfoitem:nth-child(1) {
          border: 0;
        }
      }
      .product {
        display: none;
        top: 0;
        left: 100%;
        background-color: rgba(0, 0, 0, 0.7);
      }

      .navboxtop .navboxtopitemactive, .navinfoitem:hover {
        color: #e62c3d;
        background-color: rgba(0, 0, 0, 0.7);
      }
      .navinfoitem:hover {
        .product {
          display: block;
        }
      }
      .navboxtop:hover {
        display: block;
      }
    }

    .navitem:hover,
    .active {
      .activeline {
        width: 100%;
      }

      span {
        color: #e62c3d !important;
      }
    }

    .navitem:hover {
      .default,
      .navboxtop {
        display: block;
      }
      .default {
         background-color: rgba(0, 0, 0, 0.5);
      }
      .navboximg {
        background-image: url("@/assets/image/header/arrowbottom2.png");
      }
    }
  }

  .language {
    display: flex;
    align-items: center;
    margin-right: 161px;

    .line {
      width: 2px;
      height: 12px;
      margin: 0 10px;
      background-color: #fff;
    }

    .text {
      line-height: 82px;
      font-size: 16px;
      color: #fff;
      cursor: pointer;
    }

    .activetext {
      color: #e62c3d;
    }
  }
}
</style>
